import * as THREE from 'three';
/* ── 按骨段合併（設計文件 §9）───────────────────────────────────
   151 個 primitive = 151 個 draw call，太貴；但整台合併會**把姿態鎖死**。
   折衷是把合併邊界下移到骨段：以每個 `userData.bone` 為界，把它底下
   （不含巢狀骨段）的 mesh 依材質烘成一顆。骨段之間仍然可以自由旋轉。

   結果：17 個骨段、約 40 個 mesh，動畫照跑。
   **限制：合併後的骨段內部不能再分開動。** 之後若要做「肩甲開合」那類
   細部動畫，該節點要另外標成骨段（或標 `userData.noMerge`）。

   住在自己的檔案裡是因為兩台機體都要用它：`mechs.ts`（CHASSIS-0）與
   `lancer.ts`（LANCER-2）。放在其中一邊會讓兩個檔案互相 import。 */
function mergeGeoms(list) {
  var total = 0, i;
  for (i = 0; i < list.length; i++) total += list[i].attributes.position.count;
  var pos = new Float32Array(total * 3), nor = new Float32Array(total * 3), off = 0;
  for (i = 0; i < list.length; i++) {
    pos.set(list[i].attributes.position.array, off * 3);
    nor.set(list[i].attributes.normal.array, off * 3);
    off += list[i].attributes.position.count;
    list[i].dispose();
  }
  var g = new THREE.BufferGeometry();
  g.setAttribute('position', new THREE.BufferAttribute(pos, 3));
  g.setAttribute('normal', new THREE.BufferAttribute(nor, 3));
  return g;
}
export function mergeBones(root) {
  root.updateMatrixWorld(true);
  var bones: any[] = [];
  root.traverse(function (o: any) { if (o.userData.bone) bones.push(o); });

  bones.forEach(function (bone) {
    var inv = new THREE.Matrix4().copy(bone.matrixWorld).invert();
    var kill: any[] = [], mats: any[] = [], lists: any[] = [];
    (function walk(node) {
      for (var i = 0; i < node.children.length; i++) {
        var c = node.children[i];
        if (c.userData.bone) continue;                 // 巢狀骨段自己處理
        if (c.isMesh && !c.userData.noMerge && !c.userData.noBake) {
          var g = c.geometry.clone();
          if (g.index) { var ni = g.toNonIndexed(); g.dispose(); g = ni; }
          g.applyMatrix4(new THREE.Matrix4().multiplyMatrices(inv, c.matrixWorld));
          var k = mats.indexOf(c.material);
          if (k < 0) { mats.push(c.material); lists.push([]); k = mats.length - 1; }
          lists[k].push(g); kill.push(c);
        }
        walk(c);
      }
    })(bone);
    for (var i = 0; i < kill.length; i++) kill[i].parent.remove(kill[i]);
    for (i = 0; i < mats.length; i++) {
      var m = new THREE.Mesh(mergeGeoms(lists[i]), mats[i]);
      m.castShadow = true; m.receiveShadow = true;
      bone.add(m);
    }
  });
  return root;
}
